import axios from 'axios'

const apiClient = axios.create({
  baseURL: import.meta.env.VITE_API_URL,
  timeout: 1200000, // 20 minutes
  headers: {
    'Content-Type': 'application/json',
  },
})

// Request interceptor
apiClient.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('accessToken')
    if (token) {
      config.headers.Authorization = `Bearer ${token}`
    }
    return config
  },
  (error) => {
    return Promise.reject(error)
  }
)

// Endpoints that legitimately answer 401 (wrong password, expired reset link…).
// A 401 from these means "these credentials are wrong", not "your session died",
// so the page must stay put and let the form show the error.
const AUTH_ENDPOINTS = [
  '/auth/login',
  '/auth/register',
  '/auth/logout',
  '/auth/forgot-password',
  '/auth/reset-password',
  '/auth/refresh-tokens',
]

const isAuthEndpoint = (url = '') => AUTH_ENDPOINTS.some((path) => url.includes(path))

const forceLogout = () => {
  // Clear the whole session, same keys as useAuthStore.logout()
  localStorage.removeItem('accessToken')
  localStorage.removeItem('refreshToken')
  localStorage.removeItem('user')
  localStorage.removeItem('subscription')
  localStorage.removeItem('hasActiveSubscription')

  if (window.location.pathname === '/login') return

  // Picked up by the login page to explain why the user landed there.
  sessionStorage.setItem('sessionExpired', '1')

  // Hard navigation: clears every in-memory store and any in-flight request.
  window.location.replace('/login')
}

// Response interceptor
apiClient.interceptors.response.use(
  (response) => {
    return response
  },
  (error) => {
    if (error.response) {
      switch (error.response.status) {
        case 401:
          if (!isAuthEndpoint(error.config?.url || '')) {
            forceLogout()
          }
          break
        case 403:
          console.error('Access forbidden')
          break
        case 404:
          console.error('Resource not found')
          break
        case 500:
          console.error('Server error')
          break
        default:
          console.error('Request failed:', error.message)
      }
    } else if (error.request) {
      console.error('No response received:', error.request)
    } else {
      console.error('Error setting up request:', error.message)
    }
    return Promise.reject(error)
  }
)

export default apiClient
